@use "@fukuri-admins/ui/layout" as *;

.item {
  display: flex;
  @include typography('Jp/14_W3');

  .label {
    color: text('High');
  }
  .value {
    color: text('High');
  }
}

.column {
  flex-direction: column;
  gap: spacing('4');
}

.row {
  flex-direction: row;
  align-items: flex-start;
  gap: spacing('24');

  .label {
    width: 172px;
  }
}
